/*
 * @Author: wuchenge
 * @Date:   2022-03-24 16:47:51
 * @Last Modified by:   无尘阁
 * @Last Modified time: 2022-03-25 17:38:52
 */

import { fromJS } from "immutable";
import * as types from "./types";
import { http } from "utils/http";

const changeList = (data) => ({
  type: types.HEADER_CHANGE_LIST,
  data: fromJS(data),
  totalPage: Math.ceil(data.length / 10),
});

export const searchFocus = () => ({
  type: types.HEADER_SEARCH_FOCUS,
});

export const searchBlur = () => ({
  type: types.HEADER_SEARCH_BLUR,
});

export const mouseEnter = () => ({
  type: types.HEADER_MOUSE_ENTER,
});

export const mouseLeave = () => ({
  type: types.HEADER_MOUSE_LEAVE,
});

export const changePage = (page) => ({
  type: types.HEADER_CHANGE_PAGE,
  page,
});

export const setKeyword = (keyword) => ({
  type: types.HEADER_SET_KEYWORD,
  keyword,
});

export const getList = () => {
  return (dispatch) => {
    http("/hots")
      .then((res) => {
        dispatch(changeList(res));
      })
      .catch((err) => console.log(err));
  };
};
